import * as React from 'react'
import { useLocation } from 'react-router-dom'

import { Icon } from '@factorialco/deprecated-design-system'
import { EnvironmentContext } from 'config/environment'
import { motion } from 'framer-motion'

import { observer } from 'mobx-react'

import PopoverContent from 'modules/core/components/Popover/Content'
import PopoverMenu from 'modules/core/components/PopoverMenu'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useModuleAvailabilities } from 'modules/core/hooks/useModuleAvailabilities'
import { useGraphQLClient } from 'modules/core/lib/graphql/provider'
import i18n from 'modules/core/lib/i18n'

import { ProductUpdatesSidepanel } from 'modules/onboarding/components/ProductUpdatesSidepanel'
import useCustomerSupportDetails from 'modules/onboarding/hooks/customerSupportDetails/useCustomerSupportDetails'
import useIntercom, { loadIntercom } from 'modules/onboarding/hooks/useIntercom'
import { useProductUpdatesVisibility } from 'modules/onboarding/hooks/useProductUpdatesVisibility'

import { getOptions } from './getOptions'
import * as styles from './index.vanilla.css'

function OmniButton() {
  const { pathname: currentPath } = useLocation()
  const [isPopoverOpen, setIsPopoverOpen] = React.useState(false)
  const [openNewsSidePanel, setOpenNewsSidePanel] = React.useState(false)
  const { showIntercomChat, intercomApiBase, intercomApiId } = React.useContext(EnvironmentContext)
  let { customCustomerSupportUrl } = useCustomerSupportDetails()
  customCustomerSupportUrl = customCustomerSupportUrl ?? undefined
  const session = useCurrentSession()
  const {
    email,
    access: { id: userId, firstName, lastName },
    company: {
      id: companyId,
      name: companyName,
      size: companySize,
      industry: companyIndustry,
      createdAt: companyCreatedAt,
      legalEntities,
    },
    employee,
    isIntercomAllowed,
  } = session

  const { moduleAvailabilities, loading } = useModuleAvailabilities()

  const { productName, productUpdates } = useProductUpdatesVisibility(currentPath)

  const graphQLClient = useGraphQLClient()

  const intercomData = {
    isIntercomAllowed,
    userIsAdmin: isIntercomAllowed,
    userName: `${firstName} ${lastName}`,
    userId: userId,
    userEmail: email,
    userPhone: employee?.phoneNumber ?? '',
    companyId,
    companyName,
    companySize,
    companyIndustry,
    companyCreatedAt,
    companyCountry: legalEntities[0]?.country ?? '',
  }

  const { handleIntercomClick } = useIntercom(intercomData)

  React.useEffect(() => {
    loadIntercom({ ...intercomData, intercomApiBase, intercomApiId })
  })

  const omniMotion = {
    hover: {
      scale: 1.1,
      boxShadow: '0 0 0 8px rgba(30,30,49,.1)',
    },
    tap: {
      scale: 0.95,
    },
  }
  const tagMotion = {
    default: {
      opacity: 0,
      scale: 0.5,
    },
    hover: {
      opacity: 1,
      x: -40,
      scale: 1,
    },
  }
  return (
    <>
      <div className={styles.omniButton}>
        <PopoverMenu
          type="list"
          open={isPopoverOpen}
          onClick={() => setIsPopoverOpen(!isPopoverOpen)}
        >
          <PopoverMenu.Trigger asChild>
            <motion.div initial="default" whileHover="hover" whileTap="tap">
              <motion.button
                aria-label="omnibutton"
                className={styles.button}
                variants={omniMotion}
              >
                <Icon.Medium icon="question" color="grey000White" />
                <motion.div className={styles.buttonTag} variants={tagMotion}>
                  {i18n.t('command_bar.plugins.help_center.title')}
                </motion.div>
              </motion.button>
            </motion.div>
          </PopoverMenu.Trigger>
          <PopoverMenu.Content side="top" align="center" width="s300" offset={4}>
            {!loading && (
              <PopoverContent
                options={getOptions(
                  graphQLClient,
                  moduleAvailabilities,
                  handleIntercomClick,
                  showIntercomChat,
                  session,
                  customCustomerSupportUrl
                )}
                onClose={() => setIsPopoverOpen(false)}
              />
            )}
          </PopoverMenu.Content>
        </PopoverMenu>
      </div>
      {openNewsSidePanel && (
        <ProductUpdatesSidepanel
          productUpdates={productUpdates}
          productName={productName}
          onClose={() => setOpenNewsSidePanel(false)}
          open={openNewsSidePanel}
        />
      )}
    </>
  )
}
export default observer(OmniButton)
